import { useEffect, useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const PER_PAGE_OPTIONS = [10, 50, 100, 300];

export function usePager(items, initialPer = 50) {
  const [page, setPage] = useState(1);
  const [per, setPer] = useState(initialPer);
  const total = items?.length || 0;
  const pages = Math.max(1, Math.ceil(total / per));
  const cur = Math.min(page, pages);
  useEffect(() => { setPage(1); }, [total, per]);
  const paged = useMemo(() => (items || []).slice((cur - 1) * per, cur * per), [items, cur, per]);
  return { paged, pager: { page: cur, pages, per, setPer, setPage, total } };
}

export function Pager({ page, pages, per, setPer, setPage, total, testid = "pager" }) {
  if (!total) return null;
  const from = (page - 1) * per + 1;
  const to = Math.min(page * per, total);
  const win = [];
  const lo = Math.max(1, Math.min(page - 2, pages - 4));
  for (let n = lo; n <= Math.min(pages, lo + 4); n++) win.push(n);
  return (
    <div data-testid={testid} className="flex items-center justify-between gap-2 flex-wrap pt-2">
      <div className="flex items-center gap-2">
        <span className="text-[11px] text-slate-400">per halaman</span>
        <select data-testid={`${testid}-per`} value={per} onChange={(e) => setPer(parseInt(e.target.value))}
          className="h-8 px-2 rounded-lg border border-slate-200 text-xs bg-white focus:outline-none focus:border-[#7F1D2D]">
          {PER_PAGE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-[11px] text-slate-400">Menampilkan {from.toLocaleString("id-ID")}–{to.toLocaleString("id-ID")} dari {total.toLocaleString("id-ID")}</span>
        {pages > 1 && (
          <div className="flex items-center gap-1">
            <button data-testid={`${testid}-prev`} onClick={() => setPage(Math.max(1, page - 1))} disabled={page === 1}
              className="h-8 w-8 rounded-lg border border-slate-200 text-slate-400 disabled:opacity-30 flex items-center justify-center"><ChevronLeft className="w-3.5 h-3.5" /></button>
            {win.map((n) => (
              <button key={n} data-testid={`${testid}-page-${n}`} onClick={() => setPage(n)}
                className={`h-8 min-w-8 px-1.5 rounded-lg text-xs font-semibold ${n === page ? "text-white" : "border border-slate-200 text-slate-500"}`}
                style={n === page ? { background: "#7F1D2D" } : {}}>{n}</button>
            ))}
            <button data-testid={`${testid}-next`} onClick={() => setPage(Math.min(pages, page + 1))} disabled={page === pages}
              className="h-8 w-8 rounded-lg border border-slate-200 text-slate-400 disabled:opacity-30 flex items-center justify-center"><ChevronRight className="w-3.5 h-3.5" /></button>
          </div>
        )}
      </div>
    </div>
  );
}
